
<template>
<a-form-model-item
    label="联系人姓名"
    :colon="false"
    :label-col="{span: 6}"
    :wrapper-col="{span: 18}"
    :prop="propStr"
>
    <a-input
    :value="contactName"
    :max-length="name.MAX_LENGTH"
    placeholder="请输入"
    @change="onChange" />
</a-form-model-item>
</template>

<script>
import FormValidator from '@/constants/formValidator'
import minix from './minix'

export default {
    mixins: [minix],
    model: {
        prop: 'contactName',
        event: 'change'
    },
    props: {
        contactName: {
            type: String,
            required: true
        },
        propName: {
            type: String,
            default: 'contactName'
        },
    },
    data () {
        return {
            name: FormValidator.Name
        }
    },
    methods: {
        onChange({target}) {
            this.$emit('change', target.value)
        }
    },
}
</script>
